var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableEditLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8619 1.52851C11.1223 1.26816 11.5444 1.26816 11.8047 1.52851L14.4714 4.19518C14.7318 4.45553 14.7318 4.87764 14.4714 5.13799L5.80474 13.8047C5.67971 13.9297 5.51014 13.9999 5.33333 13.9999H2.66667C2.29848 13.9999 2 13.7014 2 13.3333L2 10.6666C2 10.4898 2.07024 10.3202 2.19526 10.1952L8.86179 3.52865L10.8619 1.52851ZM9.33333 4.94273L3.33333 10.9427L3.33333 12.6666H5.05719L11.0572 6.66658L9.33333 4.94273ZM12 5.72378L13.0572 4.66659L11.3333 2.94273L10.2761 3.99992L12 5.72378Z",
    fill: "#7F7F84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableEditLogo);
export default __webpack_public_path__ + "static/media/table_edit_logo.7f0be1c269f6464c9395eec75232a322.svg";
export { ForwardRef as ReactComponent };